export const GET_RUN_REQ = "runData/GET";
export const GET_RUN_SUCCESS = "runData/GET_SUCCESS";
export const GET_RUN_ERROR = "runData/GET_ERROR";
export const RESET = "runData/RESET";
export const SET_ACTIVE_FOLDER_DATA = "runData/SET_ACTIVE_FOLDER";
